<template>
  <div>
    <ContactPerson
      v-if="valueOld"
      class="event-history-change-prop_old"
      :item="valueOld"/>
    <ContactPerson
      v-if="valueNew"
      class="event-history-change-prop_new"
      :item="valueNew"/>
  </div>
</template>
<script>
import ContactPerson from 'components/tenders/ContactPerson.vue'

export default {
  name: 'eventHistoryContactPersonChangedProps',
  data() {
    return {}
  },
  methods: {},
  computed: {
    valueOld() {
      if (!this.value?.valueOld) {
        return null
      }
      return this.value.valueOld
    },
    valueNew() {
      if (!this.value?.valueNew) {
        return null
      }
      return this.value.valueNew
    },
  },
  props: {
    value: {
      type: Object
    }
  },
  components: {
    ContactPerson
  }
}
</script>
<style scoped lang="scss">
.event-history-change-prop {
  list-style-type: decimal;
  background: #b0dbd8;
  border-radius: 0 25px 25px;
  transition: all 0.25s;
  padding-left: 100%;
  &_old {
    text-decoration: line-through;
    opacity: 0.5;
    font-size: 14px;
  }
  &_new {
    font-size: 14px;
  }
}
</style>
